import { render, staticRenderFns } from "./ModalWarning.vue?vue&type=template&id=78e644df"
import script from "./ModalWarning.vue?vue&type=script&lang=js"
export * from "./ModalWarning.vue?vue&type=script&lang=js"
import style0 from "./ModalWarning.vue?vue&type=style&index=0&id=78e644df&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78e644df')) {
      api.createRecord('78e644df', component.options)
    } else {
      api.reload('78e644df', component.options)
    }
    module.hot.accept("./ModalWarning.vue?vue&type=template&id=78e644df", function () {
      api.rerender('78e644df', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ModalWarning.vue"
export default component.exports